import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {
  Action,
  AnalyticsContext,
  Category,
  Entity,
  Page,
  Team
} from '@vio/core/src/analytics/types/Events'

import {DealFreezeAnalyticsContext} from '../../modules/slice'
import {ComponentSource, DealFreezeOnboardingSource} from '../../types'

export enum DealFreezeBannerVariant {
  /** The "Freeze a deal" room banner, no call to action. */
  Standing = 'standing',
  SeparateOffer = 'separateOffer'
}

interface Args {
  category: Category
  action: Action
  variant: DealFreezeBannerVariant
  analyticsContext: DealFreezeAnalyticsContext
  component: ComponentSource | string
}

export const trackDealFreezeBanner = ({
  category,
  action,
  variant,
  analyticsContext,
  component
}: Args) => {
  const {offerContext, leadContext, priceContext} = analyticsContext

  return trackEvent({
    category,
    entity: Entity.DealFreezeBanner,
    action,
    analyticsContext: {
      ...(offerContext && {[AnalyticsContext.OfferContext]: offerContext}),
      ...(leadContext && {[AnalyticsContext.LeadContext]: leadContext}),
      ...(priceContext && {[AnalyticsContext.PriceContext]: priceContext})
    },
    page: Page.Accommodation,
    ...(component && {component}),
    team: Team.Select,
    payload: {source: DealFreezeOnboardingSource.RoomBanner, variant}
  })
}
